import FooterLogo from "@/components/InteractiveLogo"
import RichText from "@/components/RichText"
import { PortableTextBlock } from "@portabletext/types"

interface FooterContentProps {
	settings: any
}

export default function FooterContent({settings}:FooterContentProps) {
	return (
		<div className="w-full min-h-dvh flex flex-col justify-between px-site pt-offset-header pb-4 sm:pb-6 md:pb-8 gap-y-4 sm:gap-y-6 lg:gap-y-8 bg-black dark:bg-white text-white dark:text-black">

			{settings?.contactIntro && (
				<div className="site-grid pt-offset-header">
					<div className="col-span-full lg:col-span-8">
						<div className="font-400 text-2xl sm:text-4xl md:text-6xl leading-105 text-white dark:text-black [&_strong]:font-400 [&_strong]:text-black [&_strong]:dark:text-white">
							<RichText content={settings?.contactIntro as PortableTextBlock[]} />
						</div>
					</div>
				</div>
			)}

			<div className="flex-auto site-grid items-start auto-rows-min sm:auto-rows-fr gap-y-4 sm:gap-y-6 lg:gap-y-8 border-t border-white dark:border-black pt-8 sm:pt-10 md:pt-12">

				<div className={`col-span-full sm:col-span-3 md:col-span-4 text-base sm:text-lg lg:text-xl leading-110 bg-error/20xxx`}>
					<h3 className={`text-white dark:text-black`}>New Business</h3>
					{settings?.emailNewBusiness && <p><a className='text-grey-dark dark:text-grey hover:text-white dark:hover:text-black transition duration-75' href={`mailto:${settings?.emailNewBusiness?.trim()}`}>{settings?.emailNewBusiness}</a></p>}
					{settings?.phoneNewBusiness && <p><a className='text-grey-dark dark:text-grey hover:text-white dark:hover:text-black transition duration-75' href={`tel:${settings?.phoneNewBusiness?.trim()}`}>{settings?.phoneNewBusiness}</a></p>}
				</div>

				<div className={`col-span-full sm:col-span-3 md:col-span-4 text-base sm:text-lg lg:text-xl leading-110 bg-error/20xxx`}>
					<h3 className={`text-white dark:text-black`}>General Enquiries</h3>
					{settings?.emailGeneral && <p><a className='text-grey-dark dark:text-grey hover:text-white dark:hover:text-black transition duration-75' href={`mailto:${settings?.emailGeneral?.trim()}`}>{settings?.emailGeneral}</a></p>}
					{settings?.phoneGeneral && <p><a className='text-grey-dark dark:text-grey hover:text-white dark:hover:text-black transition duration-75' href={`tel:${settings?.phoneGeneral?.trim()}`}>{settings?.phoneGeneral}</a></p>}
				</div>

				{settings?.address && <div className={`col-span-full sm:col-span-3 sm:row-start-2 md:col-span-4 text-base sm:text-lg lg:text-xl leading-110 bg-error/20xxx`}>
					<h3 className={`text-white dark:text-black`}>Find us</h3>
					<p className='text-grey-dark dark:text-grey' dangerouslySetInnerHTML={{ __html: settings?.address?.replace(/\n/g, '<br />') }} />
				</div>}

				<div className={`col-span-full sm:col-span-3 sm:row-start-2 md:col-span-4 text-base sm:text-lg lg:text-xl leading-110 bg-error/20xxx`}>
					{(settings?.socialLinks?.instagram || settings?.socialLinks?.linkedin) && <div className={`col-span-full sm:col-span-2 md:col-span-1 lg:col-span-2`}>
						<h3 className={`text-white dark:text-black`}>Socials</h3>
						{settings?.socialLinks?.instagram && <p><a className='text-grey-dark dark:text-grey hover:text-white dark:hover:text-black transition duration-75' target="_blank" href={settings?.socialLinks?.instagram}>Instagram</a></p>}
						{settings?.socialLinks?.linkedin && <p><a className='text-grey-dark dark:text-grey hover:text-white dark:hover:text-black transition duration-75' target="_blank" href={settings?.socialLinks?.linkedin}>LinkedIn</a></p>}
					</div>}
				</div>

				<div className="col-span-full sm:col-span-3 sm:col-start-10 sm:row-start-1 [@media(min-height:1024px)_and_(min-width:768px)]:col-span-full [@media(min-height:1024px)_and_(min-width:768px)]:col-start-1 [@media(min-height:1024px)_and_(min-width:768px)]:row-start-3 mobile:self-end mobile:pt-4 text-xs leading-130 -tracking-10 text-grey-dark dark:text-grey text-balance bg-error/20xxx">
					<p>© {new Date().getFullYear()} Studio DRAMA. All rights reserved.</p>
					<p>Typeset in Muster Grotesk by Florian Runge</p>
					<p>Website by <a className='text-grey-dark dark:text-grey hover:text-white dark:hover:text-black transition' href="https://olbrown.com" target="_blank">Oliver Brown</a></p>
				</div>

			</div>

			<div className="relative w-full sm:pt-2">
				<FooterLogo />
			</div>
		</div>
	)
}